const STORAGE_KEY =
    'arento.analytics.v2.acquisition';

const MAX_VALUE_LENGTH =
    2048;

const FRESH_DOCUMENT_MS =
    10 * 60 * 1000;

function getStorage() {
    if (
        typeof window ===
        'undefined'
    ) {
        return null;
    }

    try {
        return window.localStorage;
    } catch (error) {
        return null;
    }
}

function safeParse(value) {
    if (!value) {
        return null;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        return null;
    }
}

function clamp(value) {
    if (
        value === null ||
        value === undefined
    ) {
        return null;
    }

    const text =
        String(value)
            .trim();

    return text
        ? text.slice(
            0,
            MAX_VALUE_LENGTH
        )
        : null;
}

function isFreshDocument() {
    const timeOrigin =
        Number(
            typeof performance !==
            'undefined'
                ? performance.timeOrigin
                : NaN
        );

    return (
        !Number.isFinite(
            timeOrigin
        ) ||

        Date.now() -
        timeOrigin <=
        FRESH_DOCUMENT_MS
    );
}

function getReferrerOrigin() {
    if (
        typeof document ===
        'undefined' ||
        !document.referrer
    ) {
        return null;
    }

    try {
        const url =
            new URL(
                document.referrer
            );

        if (
            ![
                'http:',
                'https:'
            ].includes(
                url.protocol
            )
        ) {
            return null;
        }

        /*
         * Только origin.
         * Query/path чужого сайта
         * в analytics не тащим.
         */
        return clamp(
            url.origin
        );
    } catch (error) {
        return null;
    }
}

function readQuery() {
    if (
        typeof window ===
        'undefined'
    ) {
        return {};
    }

    const params =
        new URLSearchParams(
            window.location.search ||
            ''
        );

    return {
        utmSource:
            clamp(
                params.get(
                    'utm_source'
                )
            ),

        utmMedium:
            clamp(
                params.get(
                    'utm_medium'
                )
            ),

        utmCampaign:
            clamp(
                params.get(
                    'utm_campaign'
                )
            ),

        utmContent:
            clamp(
                params.get(
                    'utm_content'
                )
            ),

        utmTerm:
            clamp(
                params.get(
                    'utm_term'
                )
            ),

        yclid:
            clamp(
                params.get(
                    'yclid'
                )
            ),

        gclid:
            clamp(
                params.get(
                    'gclid'
                )
            )
    };
}

function createContext(
    visitId
) {
    const freshDocument =
        isFreshDocument();

    const query =
        freshDocument
            ? readQuery()
            : {};

    return {
        visitId,

        landingPath:
            typeof window !==
            'undefined'
                ? clamp(
                    window.location
                        .pathname ||
                    '/'
                )
                : '/',

        landingReferrer:
            freshDocument
                ? getReferrerOrigin()
                : null,

        utmSource:
            query.utmSource ||
            null,

        utmMedium:
            query.utmMedium ||
            null,

        utmCampaign:
            query.utmCampaign ||
            null,

        utmContent:
            query.utmContent ||
            null,

        utmTerm:
            query.utmTerm ||
            null,

        yclid:
            query.yclid ||
            null,

        gclid:
            query.gclid ||
            null,

        capturedAt:
            Date.now()
    };
}

export function getAnalyticsAcquisitionContext(
    visitId
) {
    if (!visitId) {
        return {};
    }

    const storage =
        getStorage();

    const current =
        safeParse(
            storage?.getItem(
                STORAGE_KEY
            )
        );

    /*
     * Один browser-wide visit —
     * один acquisition context,
     * независимо от количества вкладок.
     */
    if (
        current?.visitId ===
        visitId
    ) {
        const {
            capturedAt,
            ...context
        } = current;

        return context;
    }

    const next =
        createContext(
            visitId
        );

    try {
        storage?.setItem(
            STORAGE_KEY,
            JSON.stringify(next)
        );
    } catch (error) {
        // Для текущего event это не blocker.
    }

    const {
        capturedAt,
        ...context
    } = next;

    return context;
}